var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"app":"","permanent":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"text-h6"},[_vm._v(" Application ")]),_c('v-list-item-subtitle',[_vm._v(" subtext ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }